import "@/App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Preloader from "@/components/Preloader";
import Cursor from "@/components/Cursor";
import SmoothScroll from "@/components/SmoothScroll";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Work from "@/pages/Work";
import CaseStudy from "@/pages/CaseStudy";
import Services from "@/pages/Services";
import Industries from "@/pages/Industries";
import About from "@/pages/About";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

const BOT_UA = /bot|crawl|spider|slurp|bingpreview|facebookexternalhit|twitterbot|linkedinbot|whatsapp|telegrambot|pinterest|slackbot|discordbot|embedly|quora|lighthouse|pagespeed|gtmetrix|prerender/i;
const isBot = typeof navigator !== "undefined" && BOT_UA.test(navigator.userAgent);

function App() {
  const [revealed, setRevealed] = useState(isBot);
  return (
    <>
      {!isBot && <Preloader onReveal={() => setRevealed(true)} />}
      <Cursor />
      {revealed && (
        <BrowserRouter>
          <SmoothScroll>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/work" element={<Work />} />
                <Route path="/work/:slug" element={<CaseStudy />} />
                <Route path="/services" element={<Services />} />
                <Route path="/industries" element={<Industries />} />
                <Route path="/about" element={<About />} />
                <Route path="/insights" element={<Insights />} />
                <Route path="/insights/:slug" element={<InsightDetail />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy" element={<Legal kind="privacy" />} />
                <Route path="/cookies" element={<Legal kind="cookies" />} />
                <Route path="/terms" element={<Legal kind="terms" />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </SmoothScroll>
        </BrowserRouter>
      )}
    </>
  );
}

export default App;
